var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5987",
    "data-name": "Group 5987",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2564",
    "data-name": "Rectangle 2564",
    width: 24,
    height: 24,
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M82.694,11.716,87.94,6.47A1.039,1.039,0,0,0,87.213,4.7.977.977,0,0,0,86.486,5l-5.261,5.246L75.762,4.784a1.034,1.034,0,0,0-.727-.305.977.977,0,0,0-.727.305,1.022,1.022,0,0,0-.014,1.468l5.464,5.464-5.246,5.246a1.034,1.034,0,0,0-.305.727.977.977,0,0,0,.305.727,1.034,1.034,0,0,0,.727.305.977.977,0,0,0,.727-.305l5.246-5.246,5.043,5.043a1.034,1.034,0,0,0,.727.305.977.977,0,0,0,.727-.305,1.034,1.034,0,0,0,.305-.727.977.977,0,0,0-.305-.727Z",
    transform: "translate(-68.822 -0.116)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.960ed458c9323fe38d263da83d5c24ee.svg";
export { ForwardRef as ReactComponent };